import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';
import { initialMenuGroupState } from '../../models/menuGroupModel';

export const fetchMenuGroup = createAsyncThunk(
    'menuGroup/fetchMenuGroup',
    async (_, thunkAPI) => {
        try {
            const response = await apiService('/MenuGroup/GetAll');
            if (response.isSuccess) {
                return response.result;
            } else {
                return thunkAPI.rejectWithValue(response.message || 'Hata oluştu');
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const menuGroupSlice = createSlice({
    name: 'menuGroup',
    initialState: initialMenuGroupState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenuGroup.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMenuGroup.fulfilled, (state, action) => {
                state.loading = false;
                state.dataMenuGroup = action.payload;
            })
            .addCase(fetchMenuGroup.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default menuGroupSlice.reducer;
